export const WOKWI_PINS =
{
  "uno": [
    {
      "name": "A5.2",
      "x": 87,
      "y": 9,
      "signals": [
        {
          "type": "analog",
          "channel": 5
        },
        {
          "type": "i2c",
          "signal": "SCL",
          "bus": 0
        }
      ]
    },
    {
      "name": "A4.2",
      "x": 97,
      "y": 9,
      "signals": [
        {
          "type": "analog",
          "channel": 4
        },
        {
          "type": "i2c",
          "signal": "SDA",
          "bus": 0
        }
      ]
    },
    {
      "name": "AREF",
      "x": 106,
      "y": 9,
      "signals": []
    },
    {
      "name": "GND.1",
      "x": 115.5,
      "y": 9,
      "signals": [
        {
          "type": "power",
          "signal": "GND"
        }
      ]
    },
    {
      "name": "13",
      "x": 125,
      "y": 9,
      "signals": [
        {
          "type": "spi",
          "signal": "SCK",
          "bus": 0
        }
      ]
    },
    {
      "name": "12",
      "x": 134.5,
      "y": 9,
      "signals": [
        {
          "type": "spi",
          "signal": "MISO",
          "bus": 0
        }
      ]
    },
    {
      "name": "11",
      "x": 144,
      "y": 9,
      "signals": [
        {
          "type": "spi",
          "signal": "MOSI",
          "bus": 0
        },
        {
          "type": "pwm"
        }
      ]
    },
    {
      "name": "10",
      "x": 153.5,
      "y": 9,
      "signals": [
        {
          "type": "spi",
          "signal": "SS",
          "bus": 0
        },
        {
          "type": "pwm"
        }
      ]
    },
    {
      "name": "9",
      "x": 163,
      "y": 9,
      "signals": [
        {
          "type": "pwm"
        }
      ]
    },
    {
      "name": "8",
      "x": 173,
      "y": 9,
      "signals": []
    },
    {
      "name": "7",
      "x": 189,
      "y": 9,
      "signals": []
    },
    {
      "name": "6",
      "x": 198.5,
      "y": 9,
      "signals": [
        {
          "type": "pwm"
        }
      ]
    },
    {
      "name": "5",
      "x": 208,
      "y": 9,
      "signals": [
        {
          "type": "pwm"
        }
      ]
    },
    {
      "name": "4",
      "x": 217.5,
      "y": 9,
      "signals": []
    },
    {
      "name": "3",
      "x": 227,
      "y": 9,
      "signals": [
        {
          "type": "pwm"
        }
      ]
    },
    {
      "name": "2",
      "x": 236.5,
      "y": 9,
      "signals": []
    },
    {
      "name": "1",
      "x": 246,
      "y": 9,
      "signals": [
        {
          "type": "usart",
          "signal": "TX",
          "bus": 0
        }
      ]
    },
    {
      "name": "0",
      "x": 255.5,
      "y": 9,
      "signals": [
        {
          "type": "usart",
          "signal": "RX",
          "bus": 0
        }
      ]
    },
    {
      "name": "IOREF",
      "x": 131,
      "y": 191.5,
      "signals": []
    },
    {
      "name": "RESET",
      "x": 140.5,
      "y": 191.5,
      "signals": []
    },
    {
      "name": "3.3V",
      "x": 150,
      "y": 191.5,
      "signals": [
        {
          "type": "power",
          "signal": "VCC",
          "voltage": 3.3
        }
      ]
    },
    {
      "name": "5V",
      "x": 160,
      "y": 191.5,
      "signals": [
        {
          "type": "power",
          "signal": "VCC",
          "voltage": 5
        }
      ]
    },
    {
      "name": "GND.2",
      "x": 169.5,
      "y": 191.5,
      "signals": [
        {
          "type": "power",
          "signal": "GND"
        }
      ]
    },
    {
      "name": "GND.3",
      "x": 179,
      "y": 191.5,
      "signals": [
        {
          "type": "power",
          "signal": "GND"
        }
      ]
    },
    {
      "name": "VIN",
      "x": 188.5,
      "y": 191.5,
      "signals": [
        {
          "type": "power",
          "signal": "VCC"
        }
      ]
    },
    {
      "name": "A0",
      "x": 208,
      "y": 191.5,
      "signals": [
        {
          "type": "analog",
          "channel": 0
        }
      ]
    },
    {
      "name": "A1",
      "x": 217.5,
      "y": 191.5,
      "signals": [
        {
          "type": "analog",
          "channel": 1
        }
      ]
    },
    {
      "name": "A2",
      "x": 227,
      "y": 191.5,
      "signals": [
        {
          "type": "analog",
          "channel": 2
        }
      ]
    },
    {
      "name": "A3",
      "x": 236.5,
      "y": 191.5,
      "signals": [
        {
          "type": "analog",
          "channel": 3
        }
      ]
    },
    {
      "name": "A4",
      "x": 246,
      "y": 191.5,
      "signals": [
        {
          "type": "analog",
          "channel": 4
        },
        {
          "type": "i2c",
          "signal": "SDA",
          "bus": 0
        }
      ]
    },
    {
      "name": "A5",
      "x": 255.5,
      "y": 191.5,
      "signals": [
        {
          "type": "analog",
          "channel": 5
        },
        {
          "type": "i2c",
          "signal": "SCL",
          "bus": 0
        }
      ]
    }
  ],
  "led": [
    {
      "name": "A",
      "x": 25,
      "y": 42,
      "signals": [],
      "description": "Anode"
    },
    {
      "name": "C",
      "x": 15,
      "y": 42,
      "signals": [],
      "description": "Cathode"
    }
  ],
  "btn": [
    {
      "name": "1.l",
      "x": 6,
      "y": 18.5,
      "signals": []
    },
    {
      "name": "2.l",
      "x": 6,
      "y": 37.5,
      "signals": []
    },
    {
      "name": "1.r",
      "x": 85,
      "y": 18,
      "signals": []
    },
    {
      "name": "2.r",
      "x": 85,
      "y": 37.5,
      "signals": []
    }
  ],
  "dht11": [
    { "name": "VCC", "x": 10, "y": 70, "signals": [] },
    { "name": "DATA", "x": 20, "y": 70, "signals": [] },
    { "name": "GND", "x": 30, "y": 70, "signals": [] }
  ],
  "dht22": [
    { "name": "VCC", "x": 10, "y": 70, "signals": [] },
    { "name": "DATA", "x": 20, "y": 70, "signals": [] },
    { "name": "GND", "x": 30, "y": 70, "signals": [] }
  ],
  "hc-sr04": [
    { "name": "VCC", "x": 71.3, "y": 94.5, "signals": [] },
    { "name": "TRIG", "x": 81.3, "y": 94.5, "signals": [] },
    { "name": "ECHO", "x": 91.3, "y": 94.5, "signals": [] },
    { "name": "GND", "x": 101.3, "y": 94.5, "signals": [] }
  ]
}